import React from 'react'
import PropTypes from 'prop-types'
import { Spacing50 } from 'styles/sharedStyle'
import MarkdownRenderer from 'components/MarkdownRenderer'
import { Eyebrow } from 'components/Typography'
import Link from 'components/Link'
import Button from 'components/Button'
import trackGTM from 'utils/trackGTM'

import {
  BodyCopy,
  Content,
  Headline,
  Image,
  InfoButton,
  InfoHeader,
  InfoWrapper,
  Picture,
  SuperTitle,
  Wrapper,
  Container,
} from './SinglePromoCard.style'

const SinglePromoCard = ({
  background,
  bodyCopy,
  ctaCopy,
  ctaUrl,
  eyebrow,
  headline,
  image,
  pageTemplate,
  superHeadline,
  promoCardImagePlace,
}) => {
  const variant =
    {
      ContentfulPageTemplateMemorableDaysT14: 'memDays',
    }[pageTemplate] || 'default'

  return (
    <>
      {variant === 'memDays' && <Spacing50 />}
      <Container
        paddingTop={variant === 'memDays' ? 0 : null}
        paddingBottom={50}
        pt={[4, 6, 9]}
        className="SinglePromoCard">
        {!!superHeadline && <SuperTitle>{superHeadline}</SuperTitle>}
        <Content background={background}>
          <Wrapper
            variant={variant}
            {...(variant === 'memDays' && ctaUrl
              ? {
                  as: Link,
                  to: ctaUrl,
                }
              : {})}
            invert={promoCardImagePlace === 'right'}>
            <ImageRender variant={variant} image={image} />
            <InfoWrapper background={background}>
              <InfoHeader variant={variant}>
                <Eyebrow color="inherit">{eyebrow}</Eyebrow>
                <Headline color="inherit" background={background}>
                  {headline}
                </Headline>
              </InfoHeader>
              <MarkdownRenderer
                background={background}
                as={BodyCopy}
                html={bodyCopy}
                variant={variant}
              />
              {ctaCopy && ctaUrl && variant !== 'memDays' && (
                <InfoButton>
                  <Button
                    onClick={() => {
                      trackGTM(
                        'cta interaction',
                        'cta interaction',
                        'in page cta',
                        ctaCopy
                      )
                    }}
                    as={Link}
                    to={ctaUrl}
                    backgroundColor={background}>
                    {ctaCopy}
                  </Button>
                </InfoButton>
              )}
            </InfoWrapper>
          </Wrapper>
        </Content>
      </Container>
      {variant === 'memDays' && <Spacing50 />}
    </>
  )
}

const ImageRender = ({ variant, image }) => {
  return (
    <>
      {' '}
      {variant === 'memDays' &&
        (image.gatsbyImageData || image.gatsbyImageData) && (
          <Picture>
            {image.landscape.gatsbyImageData && (
              <source
                srcSet={image.landscape.gatsbyImageData}
                media="(min-width: 900px)"
              />
            )}
            <img
              src={
                (
                  image.portrait.gatsbyImageData ||
                  image.landscape.gatsbyImageData
                ).src
              }
              alt={image.altText || ''}
            />
          </Picture>
        )}
      {variant === 'default' && image.portrait && (
        <Image image={image.portrait.gatsbyImageData} />
      )}
      {variant === 'default' && image.landscape && !image.portrait && (
        <Image image={image.landscape.gatsbyImageData} />
      )}
    </>
  )
}

ImageRender.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object]).isRequired,
  variant: PropTypes.string.isRequired,
}

SinglePromoCard.propTypes = {
  background: PropTypes.string.isRequired,
  bodyCopy: PropTypes.string.isRequired,
  ctaCopy: PropTypes.string,
  ctaUrl: PropTypes.string,
  eyebrow: PropTypes.string,
  headline: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.object]).isRequired,
  pageTemplate: PropTypes.string,
  superHeadline: PropTypes.string,
  promoCardImagePlace: PropTypes.string,
}

SinglePromoCard.defaultProps = {
  ctaCopy: null,
  ctaUrl: null,
  eyebrow: null,
  headline: '',
  pageTemplate: '',
  superHeadline: null,
  promoCardImagePlace: 'left',
}

export default SinglePromoCard
